document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".accordion-item");

  items.forEach(function(item){

    const button = item.querySelector(".accordion-header");

    button.addEventListener("click", function(){

      item.classList.toggle("active");

    });

  });

});